import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface HeaderAction {
  label: string;
  variant?: 'primary' | 'secondary' | 'ghost';
  icon?: string;
  disabled?: boolean;
  /** Per-button emitter. Create an EventEmitter in the parent, subscribe to it, and pass it here. */
  emitter?: EventEmitter<void>;
}

@Component({
  selector: 'app-page-header',
  standalone: false,
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent {
  @Input() section: string = '';
  @Input() pageTitle: string = '';
  @Input() badgeText?: string;
  @Input() subtitle?: string;
  @Input() actions: HeaderAction[] = [];
  @Input() titleIconPath?: string;
  @Output() actionClick = new EventEmitter<HeaderAction>();

  onActionClick(action: HeaderAction): void {
    if (!action.disabled) {
      action.emitter?.emit();        // per-button logic
      this.actionClick.emit(action); // backward-compat fallback
    }
  }
}